interface IMockedLocations {
  code: string
  description: string
  id: number
  isActive: boolean
  projectIds: number[]
}

export const mockedLocations: IMockedLocations[] = [
  {
    projectIds: [38, 40],
    code: 'BIL.REF STORE',
    description: 'REFINERY STORAGE',
    isActive: true,
    id: 487,
  },
  {
    projectIds: [40],
    code: 'BIL.CCOB',
    description: 'CAT CO BOILER (CCOB)',
    isActive: true,
    id: 488,
  },
  {
    projectIds: [38, 40],
    code: 'BIL.ULEB',
    description: 'ULEB UNIT',
    isActive: true,
    id: 489,
  },
  {
    projectIds: [40],
    code: 'BIL.CHUB',
    description: 'CHUB UNIT',
    isActive: true,
    id: 490,
  },
  {
    projectIds: [40],
    code: 'BIL.BLEND',
    description: 'PRODUCT BLENDING',
    isActive: true,
    id: 491,
  },
  {
    projectIds: [40],
    code: 'BIL.SWS',
    description: 'SOUR WATER STRIPPER (SWS)',
    isActive: true,
    id: 492,
  },
  {
    projectIds: [38],
    code: 'BIL.MES',
    description: 'MECHANICAL ENGINEERING',
    isActive: true,
    id: 493,
  },
  {
    projectIds: [39],
    code: 'BIL.GEN PLANT',
    description: 'GENERAL PLANT',
    isActive: true,
    id: 494,
  },
  {
    projectIds: [39],
    code: 'BIL.MECH AD',
    description: 'MECHANICAL ADMINISTRATION',
    isActive: true,
    id: 495,
  },
  {
    projectIds: [39, 40],
    code: 'BIL.COKER',
    description: 'COKER UNIT',
    isActive: true,
    id: 496,
  },
  {
    projectIds: [40],
    code: 'BIL.SLEB',
    description: 'SLEB UNIIT',
    isActive: true,
    id: 497,
  },
  {
    projectIds: [39, 40],
    code: 'BIL.ALKY',
    description: 'ALKY UNIT',
    isActive: true,
    id: 498,
  },
  {
    projectIds: [39],
    code: 'BIL.ENVIROMENT',
    description: 'ENVIROMENTAL ENGINEERING',
    isActive: true,
    id: 499,
  },
  {
    projectIds: [40],
    code: 'BIL.FLARE',
    description: 'FLARE OPERATIONS',
    isActive: true,
    id: 500,
  },
  {
    projectIds: [40],
    code: 'BIL.CWT',
    description: 'COOLING WATER TOWER (CWT)',
    isActive: true,
    id: 501,
  },
  {
    projectIds: [40],
    code: 'BIL.CAT',
    description: 'CAT UNIT (FCCU)',
    isActive: true,
    id: 502,
  },
  {
    projectIds: [40],
    code: 'BIL.HF2',
    description: 'HYDROFINER #2',
    isActive: true,
    id: 503,
  },
  {
    projectIds: [],
    code: 'BIL.PLANT AIR',
    description: 'COMPRESSED AIR',
    isActive: true,
    id: 504,
  },
  {
    projectIds: [40],
    code: 'BIL.DEETHANIZR',
    description: 'DEETHANIZER UNIT',
    isActive: true,
    id: 505,
  },
  {
    projectIds: [39, 40],
    code: 'BIL.CRUDE',
    description: 'CRUDE UNIT',
    isActive: true,
    id: 506,
  },
  {
    projectIds: [40],
    code: 'BIL.RWPH',
    description: 'UTILITIES (RIVER WATER)',
    isActive: true,
    id: 507,
  },
  {
    projectIds: [39, 40],
    code: 'BIL.MECH SHOP',
    description: 'MECHANICAL SHOP',
    isActive: true,
    id: 508,
  },
  {
    projectIds: [40],
    code: 'BIL.HYBL',
    description: 'HYDROGEN PLANT (HYBL)',
    isActive: true,
    id: 509,
  },
  {
    projectIds: [40],
    code: 'BIL.OCC',
    description: 'OCC',
    isActive: true,
    id: 510,
  },
  {
    projectIds: [40],
    code: 'BIL.HF3',
    description: 'HYDROFINER #3',
    isActive: true,
    id: 511,
  },
  {
    projectIds: [40],
    code: 'BIL.POFO',
    description: 'POWERFORMER (POFO)',
    isActive: true,
    id: 512,
  },
  {
    projectIds: [40],
    code: 'BIL.WATER TRT',
    description: 'WATER CLARIFICATION & TREATING (BOHO)',
    isActive: true,
    id: 513,
  },
  {
    projectIds: [40],
    code: 'BIL.TREATER',
    description: 'TREATER UNIT',
    isActive: true,
    id: 514,
  },
  {
    projectIds: [40],
    code: 'BIL.STEAM DIST',
    description: 'STEAM DISTRIBUTION (BOHO)',
    isActive: true,
    id: 515,
  },
  {
    projectIds: [40],
    code: 'BIL.HCBL',
    description: 'HYDROCRACKER (HCBL)',
    isActive: true,
    id: 516,
  },
  {
    projectIds: [40],
    code: 'BIL.LAB',
    description: 'LABORATORY',
    isActive: true,
    id: 517,
  },
  {
    projectIds: [40],
    code: 'BIL.ASPHALT',
    description: 'ASPHALT OPERATIONS',
    isActive: true,
    id: 518,
  },
  {
    projectIds: [40],
    code: 'BIL.FUEL GAS',
    description: 'FUEL GAS DISTRIBUTION',
    isActive: true,
    id: 519,
  },
  {
    projectIds: [40],
    code: 'BIL.GAUGING',
    description: 'PUMPING & GAUGING',
    isActive: true,
    id: 520,
  },
  {
    projectIds: [40],
    code: 'BIL.DIENE',
    description: 'DIENE',
    isActive: true,
    id: 521,
  },
  {
    projectIds: [40],
    code: 'BIL.ELECT DIST',
    description: 'ELECTRICAL DISTRIBUTION',
    isActive: true,
    id: 522,
  },
  {
    projectIds: [40],
    code: 'BIL.KCOB',
    description: 'COKER CO BOILER (KCOB)',
    isActive: true,
    id: 523,
  },
  {
    projectIds: [40],
    code: 'BIL.HEAVY EQ',
    description: 'INDUSTRIAL/HEAVY EQUIPMENT',
    isActive: true,
    id: 524,
  },
  {
    projectIds: [40],
    code: 'BIL.SPLITTER',
    description: 'SPLITTER UNIT',
    isActive: true,
    id: 525,
  },
  {
    projectIds: [40],
    code: 'BIL.HF1',
    description: 'HYDROFINER #1',
    isActive: true,
    id: 526,
  },
  {
    projectIds: [40],
    code: 'BIL.API',
    description: 'SEWERS/SEPARATORS/LAGOONS',
    isActive: true,
    id: 527,
  },
  {
    projectIds: [40],
    code: 'BIL.RACK',
    description: 'RAIL & TRUCK RACKS',
    isActive: true,
    id: 528,
  },
  {
    projectIds: [40],
    code: 'BIL.SOLIDWASTE',
    description: 'SOLID WASTE MANAGEMENT',
    isActive: true,
    id: 529,
  },
  {
    projectIds: [39],
    code: 'BIL.CR STORAGE',
    description: 'CRUDE STORAGE',
    isActive: true,
    id: 530,
  },
  {
    projectIds: [40],
    code: 'BIL.COKE PRO',
    description: 'COKE SHIPPING',
    isActive: true,
    id: 531,
  },
  {
    projectIds: [],
    code: 'BIL.FIELD SHOP',
    description: 'Location: BIL.FIELD SHOP',
    isActive: true,
    id: 539,
  },
  {
    projectIds: [],
    code: 'BIL.ORST',
    description: 'FIRE, OIL SPILL & RESCUE',
    isActive: true,
    id: 540,
  },
  {
    projectIds: [],
    code: 'BIL.RERUN',
    description: 'RERUN UNIT',
    isActive: true,
    id: 541,
  },
  {
    projectIds: [],
    code: 'BIL.SECURITY',
    description: 'SECURITY',
    isActive: true,
    id: 548,
  },
  {
    projectIds: [],
    code: 'BIL.SAFETY',
    description: 'SAFETY DEPTARTMENT',
    isActive: true,
    id: 549,
  },
  {
    projectIds: [],
    code: 'BIL.HYGIENE',
    description: 'INDUSTRIAL HYGIENE',
    isActive: true,
    id: 550,
  },
  {
    projectIds: [],
    code: 'BIL.HRUB',
    description: 'HRUB UNIT',
    isActive: true,
    id: 553,
  },
  {
    projectIds: [],
    code: 'BIL.TOOLROOM',
    description: 'Location: BIL.TOOLROOM',
    isActive: true,
    id: 816,
  },
  {
    projectIds: [],
    code: 'BIL.MOB',
    description: 'MAIN OFFICE BUILDING',
    isActive: true,
    id: 1129,
  },
  {
    projectIds: [],
    code: 'BIL.STORES',
    description: 'STOREHOUSE',
    isActive: true,
    id: 1131,
  },
  {
    projectIds: [],
    code: 'BIL.LPG',
    description: 'LPG TANK CARS',
    isActive: true,
    id: 2019,
  },
  {
    projectIds: [],
    code: 'BIL.POT WATER',
    description: 'POTABLE WATER OPERATIONS',
    isActive: true,
    id: 10024,
  },
]
